export const FORM_IDS = {
  CREATE: "create-region-form",
  EDIT: "edit-region-form",
  DELETE: "delete-region-form",
};
